export default "__VITE_ASSET__C$k$MQs6__"